export default __webpack_public_path__ + "static/media/8.af8c03b9.png";